<template>
  <div  v-redirect-if-no-permission:BOOKINGS >
    <v-layout style="background-color: white" justify-end>
      <div></div>
      <!-- <h1>RED RDDD</h1> -->
      <v-select
        :items="items"
        item-text="value"
        item-value="key"
        :label="$t('reservationsPage.logActionType')"
        v-model="status"
        @change="typeFilter"
        style="max-width: 250px"
      ></v-select>
    </v-layout>

    <DataTable
      :url="api.ACTIONS.BOOKING_LOG($route.params.id)"
      :appends="['status']"
      :initial-url-search-params="requestType"
      :fields-hidden-main="[
        'deleted_at',
        'updated_at',
        'entity',
        'entity_type',
        'id',
        'entity_id',
        'requester_captain_id',
        'receiver_captain_id',
        'requester_booking_id',
        'requester_captain',
        'receiver_captain',
        'receiver_booking_id',
        'expired_time',
        'booking_id',
        'captain_id',
      ]"
      :disableSearch="true"
      :enableEdit="false"
      :enableAdd="false"
      :enableDelete="false"
      :titles="titles"
      :formatter="formatters"
    />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "BookingLog",
  title() {
    return this.$t("reservationsPage.logPageTitle");
  },
  components: {
    LoadingComponent,
    DataTable,
  },

  data() {
    return {
      loading: false,
      requestType: new URLSearchParams("type=all"),
      status: "all",
    };
  },
  mounted() {
    console.log("mounted");
  },
  methods: {
    typeFilter() {
      console.log("changed");
      this.requestType = new URLSearchParams(`type=${this.status}`);
    },
  },

  computed: {
    items() {
      return [
        { key: "all", value: this.$t("reservationsPage.logTypeAll") },
        { key: "create_booking", value: this.$t("reservationsPage.logTypeCreateBooking") },
        { key: "captain_suggestion", value: this.$t("reservationsPage.logTypeCaptainSuggestion") },
        { key: "manual_dispatch", value: this.$t("reservationsPage.logTypeManualDispatch") },
      ];
    },
    formatters() {
      const typeLabels = {
        all: this.$t("reservationsPage.logTypeAll"),
        create_booking: this.$t("reservationsPage.logTypeCreateBooking"),
        captain_suggestion: this.$t("reservationsPage.logTypeCaptainSuggestion"),
        manual_dispatch: this.$t("reservationsPage.logTypeManualDispatch"),
      };
      const actorLabels = {
        System: this.$t("reservationsPage.logActorSystem"),
        "Customer dashboard": this.$t("reservationsPage.logActorCustomerDashboard"),
        "Admin dashboard": this.$t("reservationsPage.logActorAdminDashboard"),
      };
      const statusLabels = {
        ACCEPTED: this.$t("reservationsPage.logStatusAccepted"),
        REJECTED: this.$t("reservationsPage.logStatusRejected"),
        NO_RESPONSE: this.$t("reservationsPage.logStatusNoResponse"),
        PENDING: this.$t("reservationsPage.logStatusPending"),
      };
      return {
        created_at(value) {
          return formatCompanyTime(value, "DD-MM-YYYY - HH:mm:ss");
        },
        type(value) {
          return typeLabels[value] || value;
        },
        doer(value) {
          return actorLabels[value] || value;
        },
        recipient(value) {
          return actorLabels[value] || value;
        },
        status(value) {
          if (!value) return value;
          return statusLabels[value] || value;
        },
      };
    },
    titles() {
      return {
        created_at: this.$t("reservationsPage.logColCreationDate"),
        type: this.$t("reservationsPage.logColType"),
        doer: this.$t("reservationsPage.logColDoer"),
        recipient: this.$t("reservationsPage.logColRecipient"),
        taxi_number: this.$t("reservationsPage.colTaxiNumber"),
        status: this.$t("reservationsPage.colStatus"),
        old_time: this.$t("reservationsPage.logColOldTime"),
        new_time: this.$t("reservationsPage.logColNewTime"),
      };
    },
    params() {
      const params = new URLSearchParams();
      // params.append("id", this.captain.id);
      params.append("type", "all");
      return params;
    },
  },
};
</script>

<style scoped></style>
